import {CREATE_PROJECTCOMMENTS_REQUEST, CREATE_PROJECTCOMMENTS_SUCCESS, CREATE_PROJECTCOMMENTS_FAILURE} from './projectCommentTypes'

const initialState = {
  loading: true,
  data: [],
  errorMsg: '',
};

const projectCommentsReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_PROJECTCOMMENTS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case CREATE_PROJECTCOMMENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        errorMsg: '',
      };
    case CREATE_PROJECTCOMMENTS_FAILURE:
      return {
        ...state,
        loading: false,
        data: [],
        errorMsg: action.payload,
      };
    default:
      return state;
  }
};

export default projectCommentsReducer